import { KEYCLOAK_AUTH } from 'config'
import { createAuthStrategy } from 'lib/auth'
import { keycloak, storybook } from 'lib/auth/adapters'

export const { AuthProvider, useAuth } = createAuthStrategy(
  process.env.STORYBOOK_ENV || process.env.CI
    ? storybook
    : keycloak(KEYCLOAK_AUTH)
)
